import { render } from "./DisplayPostersInPage.vue?vue&type=template&id=a6cca0b2&ts=true"
import script from "./DisplayPostersInPage.vue?vue&type=script&lang=ts"
export * from "./DisplayPostersInPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__